<template>
  <gkModal
    class="modal"
    v-model="isShow"
    @destroy="close"
    transition="gk-fade-up"
    loading
  >
    <div class="content">
      <p class="content-title">
        {{ data.detailsText.title }}
      </p>

      <div class="practice-content">
        <div v-for="(item, index) in data.detailsText.practiceList" :key="index">
          <div class="practice-list-wrapper">
            <p class="practice-name">{{item.name}}</p>
            <p class="practice-member">{{item.member}}</p>
          </div>
          <img class="practice-icon" src="@/assets/transSave/resource/image/41/3b/418abc98a27fc723d58e7c2d157c2d3b.png" alt="icon">
        </div>
      </div>
    </div>

    <div slot="footer"></div>
  </gkModal>
</template>

<script>
import gkModal from './components/gkModal.vue'

export default {
  name: 'modal-mobile',

  data: () => ({
    isShow: false
  }),

  props: [
    'data'
  ],

  components: {
    gkModal
  },

  created () {
    setTimeout(() => { this.isShow = true })

    console.log(this.data)
  },

  methods: {
    close () {
      this.$emit('close', this)
    }
  }
}
</script>

<style lang="scss" scoped>

.modal {
  ::v-deep [gk-modal-main] {
    width: 84vw;
  }

  ::v-deep [gk-modal-close] {
    &::before, &::after {
      width: 14px; height: 2px;
      background: rgba(0, 0, 0, 1);
    }
  }
}

.content {
  position: relative;
  padding: 0;
}

.content-title {
  position: relative;
  margin: 0 auto 34px;
  color: #2F2F30;
  line-height: 22px;
  font-family: Alibaba-PuHuiTi-Heavy;
  font-size: 16px; font-weight: 500;
  text-align: center;

  &::after {
    content: " ";
    position: absolute; left: 50%; bottom: -12px;
    transform: translateX(-50%);
    width: 40px; height: 5px;
    background: #DE3640;
  }
}

.practice-content {
  max-height: 370px;
  overflow-y: auto;
}

.practice-list-wrapper {
  padding: 0 0 0 18px;
}

.practice-name {
  margin-bottom: 6px;
  font-size: 14px; font-weight: 600;
  color: #353535;
  line-height: 20px;
}

.practice-member {
  font-size: 12px; font-weight: 400;
  color: #353535;
  line-height: 17px;
}

.practice-icon {
  width: 96%;
  padding: 23px 0;
}

</style>
